import { EditModal } from "../../../shared/components/edit-table/edit-modal";
import { EditTable, EditTableSortColumn } from "../../../shared/components/edit-table/edit-table";
import { TableRenderer, TableRenderType } from "../../../shared/components/edit-table/table-renderer";
import { JsonItem, PickListItem } from "../../../shared/components/web-form/web-form.objects";
import { CabMonthlySurvey } from "../../../shared/entities/cab-hub/cab-survey/cab-survey";
import { CabHubConnection } from "../../../shared/entities/cab-hub/connection/cab-hub-connection";
import { getDisplayDate, getMonthYearDisplay } from "../../../shared/scripts/date-functions";
import { CabHubTrackingPageVm } from "./cab-hub-tracking.entities";
import { CabSurveyForm } from "./cab-hub-tracking.forms";
import { CompletedSurveyTable, CompletedSurveyTableType } from "./cab-hub-tracking.tables";
import { CompletedSurveyViewModal, CompletedSurveyViewType } from "./completed-survey.view";


export class CabMemberView {
    viewModel: CabHubTrackingPageVm;
    addModal: EditModal;
    completedSurveyTable: CompletedSurveyTable;
    connectionTable: EditTable;
    tableRenderer: TableRenderer;
    completedSurveyView: CompletedSurveyViewModal;

    constructor(viewModel: CabHubTrackingPageVm) {
        this.viewModel = viewModel;
        this.tableRenderer = new TableRenderer(viewModel.PickLists);
        this.completedSurveyTable = new CompletedSurveyTable(CompletedSurveyTableType.CAB);
        this.completedSurveyView = new CompletedSurveyViewModal("survey-view-modal", viewModel.PickLists);
        this.connectionTable = this.getConnectionTable();
    }

    initialize(): void {
        this.addModal = new EditModal({
            editModalId: "survey-edit-modal",
            formSections: CabSurveyForm.getFormSections(),
            modalTitle: "CAB Survey",
            modalSubtitleFn: this.getModalSubtitle,
            saveFn: this.saveItems,
            saveBtnText: "Submit",
        });

        this.initializeActiveSurveys();
        this.initializeCompletedSurveys();    
        this.initializeConnections();
    }

    private initializeActiveSurveys(): void {
        $(".js-open-survey").on("click", (e) => {
            let target = $(e.currentTarget);
            let month = target.data("reportingMonth");
            let year = target.data("reportingYear");
            let connectionId = target.data("connectionId");

            let newSurvey = CabMonthlySurvey.getDefault(connectionId, month, year);
            this.addModal.openModal([newSurvey], this.viewModel.PickLists);
        })
    }

    private initializeCompletedSurveys(): void {
        let tableTarget = $(`#completed-survey-table-container`);
        let tableHtml = this.completedSurveyTable.generateHtml();
        tableTarget.empty().html(tableHtml);
        this.completedSurveyTable.initialize(this.viewModel.CompletedSurveys, this.viewModel.PickLists);

        $(`#completed-surveys-content`).on("shown.bs.collapse", () => {
            this.completedSurveyTable.resizeTable();
        })

        tableTarget.on("click", ".js-view-completed-survey", (e) => {
            let target = $(e.currentTarget);
            let targetId = <string>target.data("surveyId");
            let foundSurvey = this.viewModel.CompletedSurveys.find(survey => survey.SurveyId.toString() == targetId);
            if (foundSurvey) {
                this.completedSurveyView.openModal(foundSurvey, CompletedSurveyViewType.CAB);
            }
        })
    }

    private initializeConnections(): void {
        let tableTarget = $(`#connection-table-container`);
        let tableHtml = this.connectionTable.generateHtml();
        tableTarget.empty().html(tableHtml);
        this.connectionTable.initialize(this.viewModel.Connections, this.viewModel.PickLists);

        $(`#connections-content`).on("shown.bs.collapse", () => {
            this.completedSurveyTable.resizeTable();
        })
    }

    private async saveItems(items: any[], isAdd: boolean): Promise<string> {
        try {
            let saveEndpoint = "/api/cab-match/cab-survey";
            await $.ajax(saveEndpoint, {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            });

            window.location.reload(); // refresh on save;
        }
        catch {
            return "An error has occurred while saving. Please refresh the page and try again."
        }

        return "";
    }

    private getModalSubtitle(items: any[], pickLists: JsonItem[]): string {
        let returnText = "";
        if (items.length > 0) {
            let targetItem = <CabMonthlySurvey>items[0];
            let displayName = "CAB Survey";
            let displayHub = "";
            let displayDate = getMonthYearDisplay(targetItem.ReportingMonth, targetItem.ReportingYear);

            let connectionList: CabHubConnection[] = pickLists.find(list => list.Id == "connection-list")?.Json;
            let hubList: PickListItem[] = pickLists.find(list => list.Id == "pl-short-hub")?.Json;
            let cabList: PickListItem[] = pickLists.find(list => list.Id == "pl-cab-member")?.Json;

            if (connectionList != null && hubList != null && cabList != null) {
                let foundConnection = connectionList.find(connection => connection.Id == targetItem.CabHubConnectionId);
                if (foundConnection != null) {
                    let foundUser = cabList.find(user => user.Id == foundConnection?.CabMemberUserId);
                    if (foundUser) displayName = foundUser.Value;

                    let foundHub = hubList.find(hub => hub.Id == foundConnection.HubId);
                    if (foundHub) displayHub = foundHub.Value;
                }
            }

            returnText = `
                <div class="d-flex align-items-center justify-content-between">
                    <div>${displayName} ${displayHub != "" ? "|" : ""} ${displayHub}</div>
                    <div>${displayDate}</div>
                </div>
            `;
        }

        return returnText;
    }

    private getConnectionTable(): EditTable {
        let connectTable = new EditTable({
            tableId: "connection-table",
            columns: [
                { data: "HubId", title: "Hub", className: "general text-left font-size12 nowrap", render: (data: number): string => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-short-hub"); } },
                { data: "CabMemberUserId", title: "CAB Member", className: "general text-left font-size12 table-column-md", render: (data: number): string => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-cab-member"); } },
                {
                    data: "StatusId", title: "Status", className: "general text-center font-size12 nowrap",
                    render: (data: number, type: string): string => {
                        const display = this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-connection-status");
                        if (type != "display") {
                            return display;
                        }

                        return `<span class="${data == 1 ? "cab-edit-table-active-pill" : "cab-detail-table-inactive-pill"}">${display}</span>`;
                    }
                },
                { data: "StartDate", title: "Start Date", className: "general text-left font-size12 nowrap", render: (data: string, type: string): string => { return getDisplayDate(new Date(data)); } },
                { data: "EndDate", title: "End Date", className: "general text-left font-size12 nowrap", render: (data: string, type: string): string => { return getDisplayDate(new Date(data)); } }
            ],
            sortOrder: [new EditTableSortColumn(3, "desc")],
            itemDisplayName: "Connections",
            showCount: false
        });

        return connectTable;
    }
}

